// To generate a new file similar to this one, run `pay js:run gql-v1 --type=query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import type {GraphQlDocument, UseQueryOptions} from '@sail/data';

import {useQuery} from '@sail/data';
import type {V2PermissionToken} from '@stripe-internal/data-v2/types';
import {useV1Context} from '../../shared/v1Context';

import type {V1QueryOptions, V1QueryReturn} from '../types';
import type {V1ContextInput} from '../../../schema/types';

import mergeContextVariables from '../../shared/utils/mergeContextVariables';

export default function useV1Query<
  TData,
  TVariables extends {v1Context: V1ContextInput},
  TPermissions extends V2PermissionToken,
>(
  query: GraphQlDocument<TData, TVariables, TPermissions>,
  options: NoInfer<
    V1QueryOptions<GraphQlDocument<TData, TVariables, TPermissions>>
  >,
): V1QueryReturn<GraphQlDocument<TData, TVariables, TPermissions>> {
  const v1Context = useV1Context();

  const finalOptions = Object.assign({}, options, {
    variables: Object.assign({}, options?.variables, {
      v1Context: mergeContextVariables(
        v1Context,
        options?.variables?.v1Context,
      ),
    }),
  }) as UseQueryOptions<GraphQlDocument<TData, TVariables, TPermissions>>;

  return useQuery(query, finalOptions) as V1QueryReturn<
    GraphQlDocument<TData, TVariables, TPermissions>
  >;
}
